import { render, staticRenderFns } from "./sd.vue?vue&type=template&id=2878dc69&scoped=true&"
import script from "./sd.vue?vue&type=script&lang=js&"
export * from "./sd.vue?vue&type=script&lang=js&"
import style0 from "./sd.vue?vue&type=style&index=0&id=2878dc69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878dc69",
  null
  
)

export default component.exports